import './About.css'

const About = () => {
  return (
    <main className="main-content">
      <div className="featured-section">
        <div className="page-header">
          <h1 className="page-title">About Nessa Kodo</h1>
        </div>

        <div className="about-content">
          <div className="about-text">
            <p className="about-paragraph">
              Hi, I'm Nessa Kodo. I explore sound, code, and living systems. My work lives where
              algorithms meet intuition, in the space between signal and soil, circuitry and breath.
              I work with tools like Sonic Pi, Strudel, Playtronica, and custom generative systems
              to create music that supports curiosity, presence, and flow. 
            </p>
            <p className="about-paragraph">
              This channel is a space for experimentation, live coding, chill mixing sessions,
              and creative technology. Some nights are deep-listening ambient drifts, others are
              chaotic rhythm studies or playful hardware jams. New sessions and experiments drop regularly, and I invite you
              to tune in, zone out, or patch along.
            </p>
          </div>

          <div className="about-contact">
            <p className="about-paragraph">
              For inquiries about work, collaborations, or questions, please reach out at{' '}
              <a href="mailto:nessa@nessakodo.com" className="about-contact-email">
                nessa@nessakodo.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </main>
  )
}

export default About
